import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Checkbox as CheckboxNamespace } from '../../Checkbox/Checkbox.es.js';

const useSelection = ({ columns, enableRowSelection = false, enableMultiRowSelection = true, selectionType })=>{
    const determinedEnableRowSelection = typeof enableRowSelection === 'boolean' ? enableRowSelection : false;
    const determinedMultiRowSelection = typeof enableMultiRowSelection === 'boolean' ? enableMultiRowSelection : false;
    // checkbox selection will only be enabled if row selection is enabled and multi row selection is enabled as well
    const enableCheckboxSelection = determinedEnableRowSelection && determinedMultiRowSelection;
    const columnHelper = createColumnHelper();
    const onClick = useCallback((e)=>e.stopPropagation(), []);
    if (!enableCheckboxSelection) {
        return columns;
    }
    return [
        columnHelper.display({
            id: 'select',
            size: 20,
            header: ({ table })=>{
                const props = selectionType === 'all' ? {
                    checked: table.getIsAllRowsSelected(),
                    indeterminate: table.getIsSomeRowsSelected(),
                    onChange: table.getToggleAllRowsSelectedHandler()
                } : {
                    checked: table.getIsAllPageRowsSelected(),
                    indeterminate: table.getIsSomePageRowsSelected(),
                    onChange: table.getToggleAllPageRowsSelectedHandler()
                };
                return jsx("div", {
                    className: "selection-checkbox w-4",
                    children: jsx(CheckboxNamespace, {
                        ...props,
                        label: jsx("span", {
                            className: "sr-label",
                            children: "Select All"
                        })
                    })
                });
            },
            cell: ({ row })=>jsx("div", {
                    className: "selection-checkbox w-4",
                    onClick: onClick,
                    children: jsx(CheckboxNamespace, {
                        checked: row.getIsSelected(),
                        indeterminate: row.getIsSomeSelected(),
                        label: jsx("span", {
                            className: "sr-label",
                            children: "Select this row"
                        }),
                        onChange: row.getToggleSelectedHandler()
                    })
                })
        }),
        ...columns
    ];
};

export { useSelection as default, useSelection };
//# sourceMappingURL=useSelection.es.js.map
